<template lang="pug">
  v-flex(xs12 v-show="hadData" mt-4)
    v-alert(type="info" value="true") {{ records.resultMessage }}
    table(class="order-table")
      thead
        tr
          th(width="80px") 処理対象
          th(width="80px") 処理結果
          th 該当Excel行
          th メッセージ
          th(colspan=2 width="300px") エラー項目
          th(colspan=2 width="300px") キー項目
      tbody
        tr(v-for="record in records.list")
          td.text-md-left {{ getImportTargetTypeLabel(record.targetType) }}
          td.text-md-left {{ getImportResultTypeLabel(record.resultType) }}
          td.text-md-left.whitespace-normal {{ record.lineNo }}
          td.text-md-left(width="450px") {{ record.message }}
          td.text-whitespace-pre.text-md-left.no-right-border {{ getFieldErrorKeys(record.fieldErrors) | commaToNr }}
          td.text-whitespace-pre.text-md-left {{ Object.values(record.fieldErrors) | commaToNr }}
          td.text-whitespace-pre.subject.no-right-border {{ subjectKey | commaToNr }}
          td.text-whitespace-pre {{ record.subject | commaToNr }}
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      records: {
        list: [],
        resultMessage: ""
      }
    };
  },
  methods: {
    loadData(data) {
      this.records = data;
    },
    clearData() {
      this.records = {
        list: [],
        resultMessage: ""
      };
    },
    getFieldErrorKeys(fieldErrors) {
      let newList = [];
      Object.keys(fieldErrors).forEach(key => {
        let value = fieldErrors[key];
        newList.push(key);
        if (value.length > 1) {
          newList.push(" ");
        }
      });
      return newList;
    },
    displayMessage(value) {
      if (value.updateDifferenceMessage) {
        return value.message + "\r\n" + value.updateDifferenceMessage;
      } else if (0 !== Object.keys(value.fieldErrors).length) {
        return (
          value.message +
          "\r\n" +
          Object.keys(value.fieldErrors)
            .map(key => {
              return key;
            })
            .join(",")
        );
      }
      return value.message;
    }
  },
  computed: {
    ...mapGetters({
      getImportResultTypeLabel: "site/importResultTypeStringFromKey",
      getImportTargetTypeLabel: "site/importTargetTypeStringFromKey"
    }),
    hadData() {
      if (this.records == null) {
        return false;
      }
      return this.records.list.length > 0;
    },
    subjectKey: {
      get() {
        return "プランボード番号,DriverName,ルートNo＋SEQ,伝票番号";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  table-layout: auto;

  td {
    height: 48px;
    border: solid #dcdcdc;
    border-width: 1px 0px;
    vertical-align: middle;
    padding-left: 8px;
    padding-right: 8px;
  }

  th, td {
    border-right: 1px solid #E0E0E0;
  }

  th:last-child, td:last-child {
    border-right: none;
  }

  .no-right-border {
    border-right: none;
  }

  thead {
    tr {
      height: 54px;
    }

    th {
      background-color: #fff;
      position: sticky;
      top: 45px;
      z-index: 1;
    }
  }

  tbody {
    tr {
      transition: 0.3s;
    }

    tr.selected {
      background: #ECEFF1;

      td {
        background: none;
      }
    }
  }
}

.subject {
  vertical-align: top;
}
</style>
